module.exports = __webpack_public_path__ + "assets/img/lx_product.2dcc4336.png";